module.exports = __webpack_public_path__ + "static/media/ad-quality-control-icon.173d487e.svg";